import { IGetMemberChild } from '../models/members.model';
import { AxiosPromise } from 'axios';
import axios from 'axios';
import qs from 'qs';
import {
  IGetMember,
  IGetMembers,
  IMemberParams,
} from '../models/members.model';

const uri = '/mgmt/homepage-management/member';

export const getMembers = (
  params?: IMemberParams,
): AxiosPromise<IGetMembers> => {
  let _uri = uri;
  const qsParams = qs.stringify(params);
  qsParams ? (_uri += `?${qsParams}`) : (_uri += '?');
  return axios.get(_uri);
};

export const getMember = (memberCode: string): AxiosPromise<IGetMember> => {
  return axios.get(`${uri}/${memberCode}`);
};

export const getMemberChildren = (
  memberCode: string,
): AxiosPromise<IGetMemberChild> => {
  return axios.get(`${uri}/student/${memberCode}`);
};

export const updateMember = (memberCode: string, data: any): AxiosPromise => {
  console.log(memberCode);
  console.log(data);
  return axios.put(`${uri}/${memberCode}`, data, {
    headers: {
      'Content-type': 'application/json',
    },
  });
};

export const unlockAccount = (memberCode: string): AxiosPromise => {
  return axios.put(`${uri}/unlock`, { memberCode });
};
